import {createBrowserRouter, RouteObject} from 'react-router-dom'
import {RedirectionPage} from '../modules/common/pages/RedirectionPage'
import {ErrorRoute} from './ErrorRoute'
import {RootRoute} from './RootRoute'
import {AUTH_ROUTES} from '../modules/auth/AuthRoutes'
import {COMMON_ROUTES} from '../modules/common/CommonRoute'
import {ROLE_ROUTES} from '../modules/role/RoleRoute'
import {SUBMISSION_ROUTES} from '../modules/submission/SubmissionRoute'
import {USER_ROUTES} from '../modules/user/UserRoute'
import {SECTOR_ROUTES} from '../modules/sector/SectorRoute'
import {CATEGORY_ROUTES} from '../modules/category/CategoryRoute'
import {ENTITY_ROUTES} from '../modules/entity/EntityRoute'
import {AppHelmet} from '../components/utils/AppHelmet'

export const ROUTES: RouteObject[] = [
  {
    path: '/',
    element: (
      <>
        <AppHelmet title='MIITE' titlePrefix='' />
        <RootRoute />
      </>
    ),
    errorElement: (
      <>
        <AppHelmet title='Page not found.' />
        <ErrorRoute />
      </>
    ),
    children: [
      {
        path: '/',
        element: <RedirectionPage />,
      },
      ...AUTH_ROUTES,
      ...USER_ROUTES,
      ...ROLE_ROUTES,
      ...SECTOR_ROUTES,
      ...CATEGORY_ROUTES,
      ...ENTITY_ROUTES,
      ...COMMON_ROUTES,
      ...SUBMISSION_ROUTES,
    ],
  },
]

export const router = createBrowserRouter(ROUTES)
